import { render, staticRenderFns } from "./add-teacher.vue?vue&type=template&id=5e471ee7&scoped=true&"
import script from "./add-teacher.vue?vue&type=script&lang=js&"
export * from "./add-teacher.vue?vue&type=script&lang=js&"
import style0 from "./add-teacher.vue?vue&type=style&index=0&id=5e471ee7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e471ee7",
  null
  
)

export default component.exports